import store from '@/store';
import S_Auth from '../api/v1/auth';
import config from '@/__config';
import S_Init from '@/service/app/init';
import S_InitApi from '@/service/api/v1/init';
import scope from '@/service/api/v1/scope';
import params_id from '@/service/api/v1/params_id';
import pageHelper from '@/helpers/pageHelper';

export default {
  async middlewareAuth(to, from, next) {
    // CurrentUser Set
    const accessToken = S_Auth.getToken();
    let currentUser;
    if (accessToken && !store.state.stone_auth.currentUser) {
      try {
        currentUser = await S_Auth.getUser(); // 如果 token 過期，get user v2 會返回 error message "Unauthenticated."
        S_Auth.setToken(accessToken);
        S_Init.scopeInit();
        if (
          !to.params.factoryId &&
          to.name !== 'firstSignin' &&
          currentUser
        ) {
          const {
            userJoinedFactoryList,
            userHasScopeFactoryIdList,
          } = S_InitApi.getUserFactoryAccessLists(
            S_InitApi.getUserJoinedFactoryList(currentUser && currentUser.factories)
          );
          const currentFactory = currentUser.current_factory;
          const isCurrentFactoryAvailable = (
            currentFactory &&
            currentFactory.id &&
            S_InitApi.isFactoryInJoinedAndScope(currentFactory.id, userJoinedFactoryList, userHasScopeFactoryIdList)
          );
          if (isCurrentFactoryAvailable) {
            next({ path: S_InitApi.getFactoryRoutePath(currentFactory) });
            return;
          }
          const fallbackFactory = S_InitApi.getJoinedAndHasScopeFactory(userJoinedFactoryList, userHasScopeFactoryIdList);
          if (fallbackFactory && fallbackFactory.id) {
            next({ path: S_InitApi.getFactoryRoutePath(fallbackFactory) });
            return;
          }
        }
      } catch (error) {
        currentUser = null;
      }
    } else {
      currentUser = store.state.stone_auth.currentUser;
    }
    // Auth Check
    const requiresAuth = to.matched.some(
      (record) => record.meta.middleware && record.meta.middleware == 'auth',
    );
    const loginName = config.auth.login.name ? config.auth.login.name : 'login';
    const logoutName = config.auth.logout.name
      ? config.auth.logout.name
      : 'logout';
    const loginRoute = config.auth.login.route
      ? config.auth.login.route
      : '/login';

    if (requiresAuth && !currentUser) {
      const query = to.path && to.path != '/' ? { redirect: to.path } : {};
      next({ path: loginRoute, query: query });
      return;
    }
    // Login Check
    if (to.name == loginName) {
      if (!currentUser) {
        next();
        return;
      } else {
        next('/');
        return;
      }
    }

    // Logout Check
    if (to.name == logoutName) {
      if (!currentUser) {
        next(loginRoute);
        return;
      } else {
        next();
        return;
      }
    }

    if (!store.state.auth.isLoadLanguage) {
      await S_Init.packageLanguageInit();
    }
    next();
    return;
  },
  async middlewareScope(to, from, next) {
    let is_scope = true;
    if (to.meta && to.meta.has_auth) {
      is_scope = scope.$_invalidPopupOpen(to, 'page');
    }
    if (is_scope) {
      next();
    }
  },
  async middlewareParamsId(to, from, next) {
    let is_available = true;
    if (to.params) {
      is_available = params_id.$_invalidPopupOpen(to);
    }
    if (is_available) {
      next();
    }
  },

  recordPage(to, from, next) {
    pageHelper.setHistoryPage(from);
    next();
  },
};
